// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import anime from 'animejs/lib/anime.es.js';
import inview from "jquery-inview/jquery.inview.min.js";
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);


document.addEventListener("DOMContentLoaded", () => {

  /*Scroll to top when arrow up clicked BEGIN*/
  $(window).scroll(function () {
    var height = $(window).scrollTop();
    if (height > 1000) {
      $('#backtotop').fadeIn();
    } else {
      $('#backtotop').fadeOut();
    }
  });
  $(document).ready(function () {
    $("#backtotop").click(function (event) {
      event.preventDefault();
      $("html, body").animate({
        scrollTop: 0
      }, "slow");
      return false;
    });
  });
  $(document).ready(function () {
    var scroll_start = 10;
    var startchange = $('.navigation');
    var offset = startchange.offset();
    $(document).scroll(function () {
      scroll_start = $(this).scrollTop();
      if (scroll_start > offset.top) {
        $('.navigation').addClass('color-scroll');
      } else {
        $('.navigation').removeClass('color-scroll');
      }
    });
  });
  /*Scroll to top when arrow up clicked END*/
  anime({
    targets: '.hero h2',
    translateY: [40, 0],
    opacity: [0, 1],
    easing: 'easeOutExpo',
    delay: 500
  });
  anime({
    targets: '.hero .hero-img',
    translateY: [40, 0],
    opacity: [0, 1],
    easing: 'easeOutExpo',
    delay: 1000
  });
  anime({
    targets: '.hero .content-box-icon',
    translateY: [40, 0],
    opacity: [0, 1],
    easing: 'easeOutExpo',
    delay: 1500
  });
  anime({
    targets: '.header-single img',
    translateY: [40, 0],
    opacity: [0, 1],
    easing: 'easeOutExpo',
    delay: 500
  });
  anime({
    targets: '.header-single .pure-u-lg-17-24',
    translateY: [40, 0],
    opacity: [0, 1],
    easing: 'easeOutExpo',
    delay: 1000
  });
  anime({
    targets: '.text-template',
    translateY: [40, 0],
    opacity: [0, 1],
    easing: 'easeOutExpo',
    delay: 500
  });
});


// Start fade-up
var fadeUp1 = anime.timeline({
  loop: false,
  autoplay: false,
});
fadeUp1
  .add({
    targets: '.fade-up1',
    translateY: [200, 0],
    translateZ: 0,
    opacity: [0, 1],
    easing: "easeOutExpo",
    duration: 1600,
    delay: (el, i) => 10 + 200 * i
  });
// End fade-up
// Delay fadeUp
// Play fadeUp1 when scrolled into view
$('#fade-up1').one('inview', function (event, isInView) {
  if (isInView) {
    console.log('hallo');
    fadeUp1.play();
  } else {
    stop.event;
  }
});
// End fadeUp1 


// Start fade-up
var fadeUp2 = anime.timeline({
  loop: false,
  autoplay: false,
});
fadeUp2
  .add({
    targets: '.fade-up2',
    translateY: [200, 0],
    translateZ: 0,
    opacity: [0, 1],
    easing: "easeOutExpo",
    duration: 1600,
    delay: (el, i) => 10 + 200 * i
  });
// End fade-up
// Delay fadeUp

// Play fadeUp1 when scrolled into view
$('#fade-up2').one('inview', function (event, isInView) {
  if (isInView) {
    console.log('hallo');
    fadeUp2.play();
  } else {
    stop.event;
  }
});
// End fadeUp1 


// Start fade-up
var fadeUp3 = anime.timeline({
  loop: false,
  autoplay: false,
});
fadeUp3
  .add({
    targets: '.fade-up3',
    translateY: [200, 0],
    translateZ: 0,
    opacity: [0, 1],
    easing: "easeOutExpo",
    duration: 1600,
    delay: (el, i) => 10 + 200 * i
  });
// End fade-up
// Delay fadeUp

// Play fadeUp1 when scrolled into view
$('#fade-up3').one('inview', function (event, isInView) {
  if (isInView) {
    console.log('hallo');
    fadeUp3.play();
  } else {}
});
// End fadeUp1 

// Start fade-up
var fadeUp4 = anime.timeline({
  loop: false,
  autoplay: false,
});
fadeUp4
  .add({
    targets: '.fade-up4',
    translateY: [200, 0],
    translateZ: 0,
    opacity: [0, 1],
    easing: "easeOutExpo",
    duration: 1600,
    delay: (el, i) => 10 + 200 * i
  });
// End fade-up
// Delay fadeUp

// Play fadeUp1 when scrolled into view
$('#fade-up4').one('inview', function (event, isInView) {
  if (isInView) {
    console.log('hallo');
    fadeUp4.play();
  } else {}
});
// End fadeUp1 

// Start fade-up
var fadeUp5 = anime.timeline({
  loop: false,
  autoplay: false,
});
fadeUp5
  .add({
    targets: '.fade-up5',
    translateY: [200, 0],
    translateZ: 0,
    opacity: [0, 1],
    easing: "easeOutExpo",
    duration: 1600,
    delay: (el, i) => 10 + 200 * i
  });
// End fade-up
// Delay fadeUp

// Play fadeUp1 when scrolled into view
$('#fade-up5').one('inview', function (event, isInView) {
  if (isInView) {
    console.log('hallo');
    fadeUp5.play();
  } else {}
});
// End fadeUp1 

// Start fade-up
var fadeUp6 = anime.timeline({
  loop: false,
  autoplay: false,
});
fadeUp6
  .add({
    targets: '.fade-up6',
    translateY: [200, 0],
    translateZ: 0,
    opacity: [0, 1],
    easing: "easeOutExpo",
    duration: 1600,
    delay: (el, i) => 10 + 200 * i
  });
// End fade-up
// Delay fadeUp

// Play fadeUp1 when scrolled into view
$('#fade-up6').one('inview', function (event, isInView) {
  if (isInView) {
    console.log('hallo');
    fadeUp6.play();
  } else {}
});
// End fadeUp1 

// Start fade-up
var fadeUp7 = anime.timeline({
  loop: false,
  autoplay: false,
});
fadeUp7
  .add({
    targets: '.fade-up7',
    translateY: [200, 0],
    translateZ: 0,
    opacity: [0, 1],
    easing: "easeOutExpo",
    duration: 1600,
    delay: (el, i) => 10 + 200 * i
  });
// End fade-up
// Delay fadeUp

// Play fadeUp1 when scrolled into view
$('#fade-up7').one('inview', function (event, isInView) {
  if (isInView) {
    console.log('hallo');
    fadeUp7.play();
  } else {}
});
// End fadeUp1 

//Buttons
let btn = document.querySelectorAll("#product-box-button");

btn.forEach((btns) => {
  btns.addEventListener("mouseenter", (event) => {
    anime.remove(btns.querySelector('.product-image'));
    anime({
      targets: btns.querySelector('.product-image'),
      scale: 1.01,
      translateY: -20,
      easing: "easeOutExpo",
      duration: 2500
    });
    anime({
      targets: btns.querySelector('.btn-1'),
      color: "#000",
      easing: "easeOutExpo",
      duration: 3500
    });
  });
  btns.addEventListener("mouseleave", (event) => {
    anime.remove(btns.querySelector('.product-image'));
    anime({
      targets: btns.querySelector('.product-image'),
      scale: 1,
      translateY: 1,
      easing: "easeOutExpo",
      duration: 2500
    });
    anime({
      targets: btns.querySelector('.btn-1'),
      color: "#fff",
      easing: "easeOutExpo",
      duration: 3500
    });
  });
})

/*Smooth Scroll
const button = document.querySelector('.fixed-button');
const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

button.addEventListener('click', () => {
  // use anime.js
  anime({
    targets: scrollElement,
    duration: 500,
    easing: 'easeInOutQuad'
  });
});
*/
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', function (e) {
    e.preventDefault();
    var href = this.getAttribute("href");
    var elem = document.querySelector(href) || document.querySelector("a[name=" + href.substring(1, href.length) + "]");
    //gets Element with an id of the link's href 
    //or an anchor tag with a name attribute of the href of the link without the #
    window.scroll({
      top: elem.offsetTop,
      left: 0,
      behavior: 'smooth'
    });
    setTimeout(function () {
      window.location.hash = this.hash;
    }, 20);
  });
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js